module.exports = __webpack_public_path__ + "img/agent_invitet.dce461c3.jpg";